import React from 'react';
import { Form, Input, message, Modal } from 'antd';
import { KnowledgeListVo } from '@/api/knowledge';
import { ProcessListVo, saveProcess, UpdateProcess, updateProcess } from '@/api/application';

export interface EditKnowledgeProp {
  data?: ProcessListVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditKnowledge = ({ data, isEdit, updateFn, onCancel }: EditKnowledgeProp) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    // 这里可以添加提交逻辑
    form.validateFields().then(values => {
      const api = isEdit ? updateProcess : saveProcess;
      api({ ...values, id: data?.id }).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑应用' : '新增应用'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" initialValues={data}>
        <Form.Item name="name" label="应用名称" rules={[{ required: true, message: '请输入应用名称' }]}>
          <Input placeholder="请输入" />
        </Form.Item>
        <Form.Item name="welcome" label="欢迎语">
          <Input.TextArea rows={4} autoSize={false} placeholder="请输入" />
        </Form.Item>
        <Form.Item name="description" label="描述">
          <Input.TextArea rows={2} autoSize={false} placeholder="请输入" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditKnowledge;
